import { render } from "./ScoringPanel.vue?vue&type=template&id=53a5f14a&scoped=true"
import script from "./ScoringPanel.vue?vue&type=script&lang=js"
export * from "./ScoringPanel.vue?vue&type=script&lang=js"

import "./ScoringPanel.vue?vue&type=style&index=0&id=53a5f14a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53a5f14a"]])

export default __exports__